/** StakeWise V3 OsTokenVaultController — `convertToAssets(uint256)`
 *  returns ETH backing for a given osToken share amount. */
export const StakeWiseOsTokenAbi = [
  {
    name: 'convertToAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'osTokenShares' }],
    outputs: [{ type: 'uint256', name: 'assets' }],
  },
] as const
